module.exports = {
  "toolSwitcher": {
    "order": [],
    "hidden": []
  },
  "api": {},
  "project": {}
}



//////////////////
// WEBPACK FOOTER
// ./config/@sanity/default-layout.json?sanityPart=config%3A%40sanity%2Fdefault-layout
// module id = 3227
// module chunks = 0